import { styled, css, Container, Paper } from '@mui/material';

import { IconButton, BackButton } from '../common';
import { PALETTE } from '../../theme/palette';

export const StyledContainer = styled(Container)`
  margin-top: 0 !important;
  margin-bottom: 0 !important;
`;
export const StyledAwarePartnerHeader = styled('div')(
  ({ theme }) => css`
    position: relative;
    width: 100%;

    ${theme.breakpoints.up('desktop')} {
      position: relative;
      top: 0;
      left: 0;
      height: 35rem;
      overflow: hidden;
      width: auto;
    }
  `
);

export const StyledAwareAboutInfoContainer = styled('div')(
  ({ theme }) => css`
    h3 {
      margin-top: ${theme.spacing('2XL')};
    }
    p {
      margin-bottom: ${theme.spacing('2XL')};
    }
  `
);

export const StyledOnlineVetCoverImage = styled('img')(
  ({ theme }) => css`
    width: 100%;
    max-width: 100%;
    height: auto;
    ${theme.breakpoints.up('desktop')} {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) scale(0.65);
      width: auto;
      max-width: unset;

      height: 54rem;
      object-fit: cover;
    }
  `
);

export const StyledContentTextHeader = styled('div')(
  ({ theme }) => css`
    margin-bottom: ${theme.spacing('2XL')};
    span {
      display: inline-block;
    }
    h1 {
      display: inline-block;
    }
  `
);

export const StyledVoucherContainer = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    background: ${theme.palette.common.white};
    border-color: ${theme.palette.main.product_blue};
    border-radius: ${theme.spacing('XSMALL')};
    padding: ${theme.spacing('SMALL')};
    align-items: center;
    margin: auto;
    margin-top: ${theme.spacing('MEDIUM')};
    border: 1px dashed;
    row-gap: ${theme.spacing('MEDIUM')};
  `
);

export const StyledVoucherCopyContainer = styled('div')(
  ({ theme }) => css`
    display: flex;
    column-gap: ${theme.spacing('SMALL')};
    align-items: center;

    &:focus {
      box-shadow: ${theme.shadows[3]};
    }
    p {
      margin-bottom: ${theme.spacing('MEDIUM')};
    }
  `
);

export const StyledIconButton = styled(IconButton)`
  img {
    width: auto;
    height: auto;
  }
  width: auto;
  height: auto;
`;

export const StyledBackButton = styled(BackButton)(
  ({ theme }) => css`
    z-index: 1;
    position: absolute;
    top: 2rem;

    margin: auto;
    width: 100%;
    padding: 0rem;
    ${theme.breakpoints.up('desktop')} {
      position: relative;
      top: 4.0625rem;
      display: flex;
      width: 43.75rem;
    }
  `
);
export const StyledPaper = styled(Paper)(
  ({ theme }) => css`
    border-radius: ${theme.spacing('LARGE')};
    box-shadow: none;
    background-color: ${PALETTE.CLEAR_LIGHT_VIOLET};
  `
);
export const StyledItemContainer = styled('div')(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    margin-bottom: ${theme.spacing('LARGE')};
  `
);
export const StyledNumberImg = styled('img')`
  width: auto;
`;
export const StyledArrowImg = styled('img')`
  width: auto;
  display: block;
  margin: 0 auto;
`;

export const StyledItemsContainer = styled('div')(
  ({ theme }) => css`
    h2 {
      margin-bottom: ${theme.spacing('LARGE')};
    }
  `
);

export const StyledSectionTwoContainer = styled('div')(
  ({ theme }) => css`
    display: flex;
    column-gap: ${theme.spacing('MEDIUM')};
  `
);
